import React from "react";
import ResolutionTraceField from "./ResolutionTraceField";

export default function ResolutionTraceFieldPage() {
  return <ResolutionTraceField />;
}
